import { fromJS } from 'immutable';
import {ACTIONS} from "../containers/Surveys/actions/conservationActions";

const INITIAL_STATE = fromJS({
    siteName: '',
    staticUrl: '',
    gateway: null,
    isGatewayLocalized: false,
    languages: [],
    currentLanguage: '',
    liveMapPage: false,
    isEditing: false
});

/* actions */
export const actionTypes = {
    UPDATE_SITE_STATE: 'UPDATE_SITE_STATE',
    UPDATE_EDIT_SHAPES_STATUS: 'UPDATE_EDIT_SHAPES_STATUS'
};

const updateSiteState = siteState => ({
    type: actionTypes.UPDATE_SITE_STATE,
    siteState
});

export function isDrawing(isEditing) {
    return {
        type: ACTIONS.UPDATE_EDIT_SHAPES_STATUS,
        isEditing
    }
}

export const actions = {
    updateSiteState
};

/* reducer */
export const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_SITE_STATE:
            return state.merge(fromJS(action.siteState));
        case actionTypes.UPDATE_EDIT_SHAPES_STATUS:
            return state.set("isEditing", action.isEditing);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./source/modules/site.js